<template>
  <div>
    <Modal v-model="modalShow" :title="$t('批量设置评分')" width="600"
      ><!-- 批量设置评分 -->
      <Form label-position="left" :label-width="150">
        <Row :gutter="10">
          <Col span="24">
            <FormItem :label="$t('WHAT_Assessment_PPT')"
              ><!-- WHAT评分 -->
              <Select
                v-model="formItem.whatScore"
                clearable
                transfer
                style="width: 100%"
                @on-change="
                  targetItemChange(formItem.whatScore, formItem.howScore)
                "
              >
                <Option
                  v-for="item in Score"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem :label="$t('HOW_Assessment_PPT')"
              ><!-- HOW评分 -->
              <Select
                v-model="formItem.howScore"
                clearable
                transfer
                style="width: 100%"
                @on-change="
                  targetItemChange(formItem.whatScore, formItem.howScore)
                "
              >
                <Option
                  v-for="item in Score"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem :label="$t('Overall_Assessment_PPT')"
              ><!-- Overall评分 -->
              <Select
                v-model="formItem.wholeScore"
                clearable
                transfer
                style="width: 100%"
                disabled
              >
                <Option
                  v-for="item in Score"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24" v-if="isShowPotentialScore">
            <FormItem :label="$t('Potential_Rating')"
              ><!-- 潜能评分 -->
              <Select
                v-model="formItem.potentialScore"
                clearable
                transfer
                style="width: 100%"
              >
                <Option
                  v-for="item in PotentialScore"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <slot name="other-score"></slot>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" @click="confirm"
          ><!-- 保存 -->{{ $t("Save") }}</Button
        >
        <Button type="text" @click="cancle"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    isShowPotentialScore: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modalShow: false,
      Score: [],
      PotentialScore: [],
      formItem: {
        year: "",
        dataList: [],
      },
      spinShow: false,
      overallScoreList: [],
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.Score = res.Score;
          this.PotentialScore = res.PotentialScore;
        }
      });
    },
    confirm() {
      this.modalShow = true;
      if (!this.checkScore(this.formItem)) {
        this.$Modal.confirm({
          title: this.$t("longText55"),
          onOk: () => {
            this.saveScore();
          },
        });
      } else {
        this.$Modal.confirm({
          title: "是否确认？",
          onOk: () => {
            this.saveScore();
          },
        });
      }
    },
    targetItemChange(whatScore, howScore) {
      console.log(whatScore, howScore);
      if (whatScore && howScore) {
        console.log(whatScore, howScore, "111111111111");
        this.formItem.wholeScore = this.getOverallScore(whatScore, howScore);
      }
    },
    getOverallScore(whatScore, howScore) {
      let overallScore = "";
      this.overallScoreList.forEach((res) => {
        if (whatScore == res.whatScore && howScore == res.howScore) {
          overallScore = res.overallScore;
        }
      });
      return overallScore;
    },
    saveScore() {
      this.spinShow = true;

      axios
        .post("/achReport/saveEmpAchScoreList", this.formItem)
        .then((res) => {
          this.spinShow = false;
          if (res) {
            if (res.result == 22) {
              this.$emit("batchScoringConfirm2", res);
            } else {
              this.modalShow = false;
              this.$emit("batchScoringConfirm", "");
            }
          }
        });
    },
    cancle() {
      this.modalShow = false;
    },
    checkScore(item) {
      let wholeScore = Number(item.wholeScore);
      let whatScore = Number(item.whatScore);
      let howScore = Number(item.howScore);
      // Overall分数不大于What或How的单项分数
      // 当What和How的分数差异大于1时，Overall的分数需在What和How的分数中间
      if (wholeScore > whatScore && wholeScore > howScore) {
        return false;
      } else if (
        whatScore - howScore > 1 &&
        (wholeScore >= whatScore || wholeScore <= howScore)
      ) {
        return false;
      } else if (
        howScore - whatScore > 1 &&
        (wholeScore >= howScore || wholeScore <= whatScore)
      ) {
        return false;
      }
      return true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/modalComponents/BatchScoring.vue